module.exports = __webpack_public_path__ + "static/media/Avenir-Book.71759724.eot";